/*
 * Copyright (c) 2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: Login.tsx
 * Project: mle-client
 * Committed last: 2021/10/25 @ 1138
 * ---
 */

import React, { useCallback, useState } from 'react';
import {
  Button,
  Card,
  Divider,
  Intent,
  NonIdealState
}                                       from '@blueprintjs/core';
import { useParams }                    from 'react-router';
import {
  ResetPasswordForm,
  ResetPasswordFormValues
}                                       from '../components/forms/ResetPasswordForm';
import { mleAuthProviderRestClient }    from '../api/ap';
import { MleToaster }                   from '../common/toast';
import {
  AuthPaths
}                                       from '../paths/auth.paths';
import { redirect }                     from '../common/utils';

export const ResetPassword = () => {
  const [same, setSame] = useState(true);
  const [success, setSuccess] = useState(false);
  const params = useParams();

  const handleFormSubmit = useCallback((values: ResetPasswordFormValues) => {
    // Check are the same
    if (values.password1 !== values.password2) {
      setSame(false);
      return;
    }

    setSame(true);

    const token = params.token;

    (async () => {
      try {
        await mleAuthProviderRestClient.post(`/auth/${ token }/reset-password`,
          {
            newPassword: values.password1
          });

        setSuccess(true);
      } catch (e) {
        MleToaster.getInstance().show({
          message: 'Impossibile impostare nuova password',
          intent: Intent.DANGER
        });

        setSuccess(false);
      }
    })();
  }, [params.token]);

  return (
    <div className="mle-center-both-axes-parent">
      <div className="mle-center-both-axes-child w-96">
        <Card className="w-96">
          { !success ? <div><h4 className="bp4-heading">Reimposta password</h4>
                       <Divider className="my-4"/>
                       <div className="text-bpgray-200 my-2">La nuova password deve
                         contenere
                         almeno 7 caratteri e un numero
                       </div>
                       <a href="/auth/login">Torna al login</a>
                       {
                         !same &&
                         <div className="text-red-300 text-xs">Le password inserite non
                           corrispondono</div>
                       }
                       <ResetPasswordForm
                         onSubmit={ handleFormSubmit }/></div> :
            <NonIdealState icon="tick" title="Password modificata con successo"
                           description={ <Button
                             onClick={ () => redirect(AuthPaths.LOGIN) }
                             intent={ Intent.PRIMARY }>Vai
                             al login</Button> }>
            </NonIdealState> }
        </Card>
      </div>
    </div>
  );
};